interface Props {
  wifiName: string | null
  wifiPassword: string | null
  checkoutTime: string | null
  quietHoursLine: string | null
  compactRules: string[]
}

export function EssentialsSlide({ wifiName, wifiPassword, checkoutTime, quietHoursLine, compactRules }: Props) {
  return (
    <div className="tv-essentials">
      <h2 className="tv-essentials__title">House Essentials</h2>

      <div className="tv-essentials__grid">
        {wifiName && (
          <div className="tv-essentials__item">
            <span className="tv-essentials__label">WiFi</span>
            <span className="tv-essentials__value tv-essentials__mono">{wifiName}</span>
            {wifiPassword && (
              <span className="tv-essentials__value tv-essentials__mono tv-essentials__value--sub">{wifiPassword}</span>
            )}
          </div>
        )}

        {checkoutTime && (
          <div className="tv-essentials__item">
            <span className="tv-essentials__label">Checkout</span>
            <span className="tv-essentials__value">{checkoutTime}</span>
          </div>
        )}

        {quietHoursLine && (
          <div className="tv-essentials__item">
            <span className="tv-essentials__label">Quiet hours</span>
            <span className="tv-essentials__value">{quietHoursLine}</span>
          </div>
        )}

        {compactRules.map((rule, i) => (
          <div key={i} className="tv-essentials__item">
            <span className="tv-essentials__value">{rule}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
